// eslint-disable-next-line no-restricted-imports
import { FormControlLabel } from '@mui/material';

import { styled } from '../styled';

export const ControlLabelStyled = styled(FormControlLabel)(() => ({
  margin: 0,
  gap: 6,
}));
